const config = {
  type: 'localStorage', // 本地存储类型 sessionStorage
  prefix: 'webapp_storage', // 名称前缀 建议：项目名
  expire: 60 * 60 * 24 * 360 * 100, // 过期时间 单位：秒,默认一百年
}

// 设置 setStorage
export const setStorage = (key, value, expire = 0) => {
  if (value === '' || value === null || value === undefined) {
    value = null
  }

  if (isNaN(expire) || expire < 0) throw new Error('Expire must be a number')

  expire = expire || config.expire
  const data = {
    value: value, // 存储值
    time: Date.now(), // 存值时间戳
    expire: expire, // 过期时间
  }
  window[config.type].setItem(autoAddPrefix(key), JSON.stringify(data))
}

// 获取 getStorage
export const getStorage = (key) => {
  key = autoAddPrefix(key)
  // key 不存在判断
  if (!window[config.type].getItem(key) || JSON.stringify(window[config.type].getItem(key)) === 'null') {
    return null
  }

  // 优化 持续使用中续期
  const storage = JSON.parse(window[config.type].getItem(key))

  const nowTime = Date.now()
  // 过期删除
  if ((storage.expire || config.expire) * 1000 < nowTime - storage.time) {
    removeStorage(key)
    return null
  } else {
    // 未过期期间被调用 则自动续期 进行保活
    setStorage(autoRemovePrefix(key), storage.value, storage.expire)
    return storage.value
  }
}

// 获取所有key
export const getStorageKeys = () => {
  const items = getStorageAll()
  const keys = []
  for (let index = 0; index < items.length; index++) {
    keys.push(items[index].key)
  }
  return keys
}

// 根据索引获取key
export const getStorageForIndex = (index) => {
  return window[config.type].key(index)
}

// 获取localStorage长度
export const getStorageLength = () => {
  return window[config.type].length
}

// 获取全部 getAllStorage
export const getStorageAll = () => {
  const len = window[config.type].length // 获取长度
  const arr = [] // 定义数据集
  for (let i = 0; i < len; i++) {
    // 获取key 索引从0开始
    const getKey = window[config.type].key(i)
    // 获取key对应的值
    const getVal = window[config.type].getItem(getKey)
    // 放进数组
    arr[i] = { key: getKey, val: getVal }
  }
  return arr
}

// 删除 removeStorage
export const removeStorage = (key) => {
  window[config.type].removeItem(autoAddPrefix(key))
}

// 清空 clearStorage
export const clearStorage = () => {
  window[config.type].clear()
}

// 名称前自动添加前缀
const autoAddPrefix = (key) => {
  const prefix = config.prefix ? config.prefix + '_' : ''
  return prefix + key
}

// 移除已添加的前缀
const autoRemovePrefix = (key) => {
  const len = config.prefix ? config.prefix.length + 1 : ''
  return key.substr(len)
  // const prefix = config.prefix ? config.prefix + '_' : '';
  // return  prefix + key;
}
